import { useLeverage } from '@ui/features/Trade/store/useLeverage';
import { useMemo } from 'react';

import { useCurrentLeverageMargin } from '../../TradeModule/hooks/useCurrentLeverageMargin';

export const useIsLeverageMaxReached = () => {
  const leverage = useLeverage();
  const currentLeverageMargin = useCurrentLeverageMargin();

  return useMemo(
    () => leverage === currentLeverageMargin?.maxLeverage,
    [currentLeverageMargin?.maxLeverage, leverage],
  );
};
